import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { MapPin } from 'lucide-react';
const names = ['Camila', 'Florencia', 'Luciana', 'Valeria', 'Mariana', 'Sofía', 'Martina', 'Valentina', 'Julieta', 'Agustina'];
const cities = ['Córdoba', 'Rosario', 'Buenos Aires', 'Mendoza', 'La Plata', 'Mar del Plata', 'Salta', 'Santa Fe', 'Tucumán', 'Neuquén'];
export function PurchasePopup() {
  const [isVisible, setIsVisible] = useState(false);
  const [currentPurchase, setCurrentPurchase] = useState({
    name: '',
    city: '',
    time: ''
  });
  useEffect(() => {
    const showPopup = () => {
      const randomName = names[Math.floor(Math.random() * names.length)];
      const randomCity = cities[Math.floor(Math.random() * cities.length)];
      const randomTime = Math.floor(Math.random() * 59) + 1;
      setCurrentPurchase({
        name: randomName,
        city: randomCity,
        time: `Hace ${randomTime} min`
      });
      setIsVisible(true);
      setTimeout(() => {
        setIsVisible(false);
      }, 5000);
    };
    // Initial delay
    const initialTimer = setTimeout(showPopup, 10000);
    // Recurring
    const interval = setInterval(() => {
      showPopup();
    }, 25000);
    return () => {
      clearTimeout(initialTimer);
      clearInterval(interval);
    };
  }, []);
  return <AnimatePresence data-id="element-148" data-mp="n74vinzr9v0w">
      {isVisible && <motion.div initial={{
      opacity: 0,
      y: 50,
      scale: 0.9
    }} animate={{
      opacity: 1,
      y: 0,
      scale: 1
    }} exit={{
      opacity: 0,
      y: 20,
      scale: 0.9
    }} className="fixed bottom-4 left-4 right-4 md:left-auto md:right-4 md:w-80 bg-white rounded-2xl shadow-xl p-4 z-50 border border-emerald-100 flex items-center gap-4" data-id="element-149" data-mp="n7wkhfyukui7">
          <div className="w-12 h-12 bg-emerald-100 rounded-full flex items-center justify-center flex-shrink-0" data-id="element-150" data-mp="23kv4o95qf9he">
            <span className="text-teal-700 font-bold text-lg" data-id="element-151" data-mp="2aobg6ud8gczo">
              {currentPurchase.name.charAt(0)}
            </span>
          </div>
          <div className="flex-1" data-id="element-152" data-mp="2km7o7davirtk">
            <p className="text-sm text-gray-800 font-medium" data-id="element-153" data-mp="2ko29isq24ly6">
              <span className="font-bold" data-id="element-154" data-mp="2pmdk55o6f0hg">{currentPurchase.name}</span> compró
            </p>
            <p className="text-xs text-teal-700 font-semibold" data-id="element-155" data-mp="1rybvejofdk22">
              Gimnasia Postural Resuelta
            </p>
            <div className="flex items-center gap-1 mt-1 text-xs text-gray-500" data-id="element-156" data-mp="1wwdf96todnel">
              <MapPin size={10} data-id="element-157" data-mp="21vpy7ghfeabw" />
              <span data-id="element-158" data-mp="21vhlppp7t718">
                {currentPurchase.city} • {currentPurchase.time}
              </span>
            </div>
          </div>
        </motion.div>}
    </AnimatePresence>;
}